export default __webpack_public_path__ + "static/media/zip.38144704.svg";